import { useState } from 'react';
import type { FormEvent } from 'react';
import { api } from '../api';
import type { SignedInUser } from '../api';
import { Button, ErrorBanner, Field, Stack, describe } from '../ui';

export function Login({ onSignedIn }: { onSignedIn: (user: SignedInUser) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await api.auth.login(email, password));
    } catch (cause) {
      setError(describe(cause));
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <form
        onSubmit={submit}
        className="w-[min(360px,100%)] rounded-xl border border-divider bg-raised p-5"
      >
        {/* The companion's icon, so the console and the app on the till read as one product.
            Decorative: the heading beside it already says the name. icon-mark.png is the
            icon cropped to its drawing, so it lines up with the text instead of sitting
            inside the square icon's transparent margin. */}
        <img src="/icon-mark.png" alt="" width={32} height={56} className="mb-3 h-14 w-auto" />
        <h1 className="mb-1 text-[22px] font-semibold">MPOSMobilePay</h1>
        <p className="mt-0 mb-4 text-muted">Sign in to the admin console</p>

        <ErrorBanner message={error} />

        <Stack>
          <Field label="Email">
            <input
              type="email"
              autoComplete="username"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Field label="Password">
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          <Button type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </Stack>
      </form>
    </div>
  );
}
